module.exports = __webpack_public_path__ + "static/media/ic_image_not_found.f9f8e3a9.png";